"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccumulatedKnowledge = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const Tags_1 = require("../../Tags");
const OrOptions_1 = require("../../../inputs/OrOptions");
const SelectCard_1 = require("../../../inputs/SelectCard");
const SelectOption_1 = require("../../../inputs/SelectOption");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../../render/CardRenderer");
class AccumulatedKnowledge extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ACCUMULATED_KNOWLEDGE,
            tags: [Tags_1.Tags.SCIENCE],
            metadata: {
                cardNumber: 'Y08',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.cards(4).br;
                    b.minus().cards(1).nbsp().plus().cards(1);
                }),
                description: 'Draw 4 cards. You may discard a card to draw a card.',
            },
        });
    }
    play(player) {
        const game = player.game;
        player.drawCard(4);
        game.defer(new DeferredAction_1.DeferredAction(player, () => new OrOptions_1.OrOptions(new SelectCard_1.SelectCard('Discard a card to draw a card', 'Discard', player.cardsInHand, (foundCards) => {
            const discardedCard = player.cardsInHand.splice(player.cardsInHand.indexOf(foundCards[0]), 1)[0];
            game.dealer.discard(discardedCard);
            const drawnCard = game.dealer.dealCard(game);
            player.cardsInHand.push(drawnCard);
            game.log('You discarded ${0} and drew ${1}', (b) => b.card(discardedCard).card(drawnCard), { reservedFor: player });
            return undefined;
        }), new SelectOption_1.SelectOption('Do nothing', 'Confirm', () => {
            return undefined;
        }))));
        return undefined;
    }
}
exports.AccumulatedKnowledge = AccumulatedKnowledge;
//# sourceMappingURL=AccumulatedKnowledge.js.map